import store from "app/redux/store/store"
import globalMU from "globalMU"
import { compareObjects } from "./compareObjects"

declare var window: any

const verificarIgualdadeOrcamento = ({repetir, timeout, contador, exibirAlertaUsuario}:{repetir: boolean, timeout: number, contador: number, exibirAlertaUsuario: boolean}) => {
    const orcamentoRedux = store?.getState?.()?.orcamento
    const orcamentoLegado = window?.orcamentoController?.model?.toJSON?.()

    if (orcamentoRedux != null && orcamentoLegado != null) {
        const resultadoComparacao = compareObjects(orcamentoLegado, orcamentoRedux, "orcamentoLegado", "orcamentoRedux")

        if (resultadoComparacao.equal == false) {
            if (exibirAlertaUsuario) {
                globalMU.showWarnMessage(resultadoComparacao.message)
            }
            
            console.warn(`${resultadoComparacao.message} (${contador})`)
        } else {
            console.log(`orcamentos iguais (${contador})`)
        }
    }

    if (repetir) {
        setTimeout(() => verificarIgualdadeOrcamento({repetir: true, timeout, contador: contador+1, exibirAlertaUsuario}), timeout)
    }
    
}



export const verificacaoContinuaIgualdadeEstados = () => {
    verificarIgualdadeOrcamento({repetir: true, timeout: 5000, contador: 1, exibirAlertaUsuario: false})

}


